module.exports = __webpack_public_path__ + "img/chinesecompany174.cfc3cd37.png";